import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import TextInput from "../../../sharedComponents/textInput/textInput";
import Formatter, { CapitalizationType } from "../../../../helpers/formatter";

interface AdditionalClausesProps {
  calculateStore?: CalculateStore;
}

export function AdditionalClauses(props: AdditionalClausesProps) {
  const calculateStore = props.calculateStore!;
  const value: string = calculateStore.additionalClauses;

  return (
    <div className="additional-clauses">
      <div className="question-answer-container">
        <div className="question">Postanowienia dodatkowe</div>
        <TextInput
          value={value}
          multiline={true}
          rows={4}
          onChange={(newVal) => {
            const formattedValue = Formatter.capitalizeWords(newVal, CapitalizationType.full);
            calculateStore.setAdditionalClauses(formattedValue);
          }} />
      </div>
    </div>
  );
}

export default inject("calculateStore")(observer(AdditionalClauses));
